<div class="add-line" [class.disabled]="disabled" [attr.disabled]="disabled">
  <div class="line"></div>
  <div class="add-icon">
    <ng-container *ngIf="!iconTemplate; else iconTemplate">
      <rt-icon name="add"></rt-icon>
    </ng-container>
  </div>
  <div class="line"></div>
</div>
